<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px">
    <CasePlanAndServicesEdition is-in-dialog />
  </v-dialog>
</template>

<script>
  import CasePlanAndServicesEdition from '@/components/CasePlanAndServicesEdition'
  import dialogMixins from '@/mixins/EditResourceDialog'

  export default {
    components: { CasePlanAndServicesEdition },
    mixins: [ dialogMixins ],
    mounted () {
      // TODO remove this dirty hack :'(
      this.$bus.$on('dialog-close', () => {
        this.dialogClose()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditCasesDialog.vue?45b9e1cb